export default "__VITE_ASSET__CE47Y7M0__"